"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundSchema = exports.roundReferenceSchema = void 0;
const zod_1 = require("zod");
const time_period_schema_1 = require("./time-period.schema");
const roundNumberSchema = zod_1.z.number().int().min(1).describe("Round ordinal number from 1");
// A round is a coordinate of a calculator within its group, so it carries a key like a district or a variant does. The key is a
// slug in the language of the data it belongs to (`2-kolo`, `2nd-round`); the ordinal number stays machine-readable.
const roundKeySchema = zod_1.z
    .string()
    .trim()
    .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)
    .describe("Human-friendly unique key of a round in the hyphen-separated lowercased format");
exports.roundReferenceSchema = zod_1.z.object({ key: roundKeySchema }).strict().describe("Reference to a round of an election");
exports.roundSchema = zod_1.z
    .object({
    key: roundKeySchema,
    number: roundNumberSchema,
    votingHours: zod_1.z.array(time_period_schema_1.timePeriodSchema).min(1).describe("One or multiple voting hours for the round").optional(),
})
    .strict()
    .describe("Round of an election");
